import { render, staticRenderFns } from "./AddressFieldSet.vue?vue&type=template&id=64ee5e89"
import script from "./AddressFieldSet.vue?vue&type=script&lang=ts"
export * from "./AddressFieldSet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports